import { render, staticRenderFns } from "./AppsAppCard.vue?vue&type=template&id=f51cf042&scoped=true&"
import script from "./AppsAppCard.vue?vue&type=script&lang=js&"
export * from "./AppsAppCard.vue?vue&type=script&lang=js&"
import style0 from "./AppsAppCard.vue?vue&type=style&index=0&id=f51cf042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f51cf042",
  null
  
)

export default component.exports